import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    dialog: {
        validate: "Valider",
        cancel: "Annuler"
    },
    deleteDialogHeaderWithLabelFieldHtmlTemplate: (labelField: string) => `Voulez vous vraiment supprimer/modifier <b>${labelField}</b>`,
    deleteDialogHeaderHtmlTemplate: (numberOfElements: number) => `Voulez vous vraiment supprimer/modifier <b>${numberOfElements} élément(s)</b>`
};

export type I18nDialogTools = typeof _fr;

const _en: I18nDialogTools = {
    dialog: {
        validate: "Validate",
        cancel: "Cancel"
    },
    deleteDialogHeaderWithLabelFieldHtmlTemplate: (labelField: string) => `Do you with to delete / alter <b>${labelField}</b>`,
    deleteDialogHeaderHtmlTemplate: (numberOfElements: number) => `Do you wish to delete / alter <b>${numberOfElements} element(s)</b>`
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function i18nDialogTools(lang?: string): I18nDialogTools {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}